import React, { useEffect, useState } from "react";
import { submitNetlifyForm } from "./netlifyForms";
import { useReveal } from "./useReveal";
import { fireConfetti } from "./confetti";
import "./ContactPage.css";

const ContactPage: React.FC = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [website, setWebsite] = useState(""); // honeypot — humans never see or fill this
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  useReveal();

  useEffect(() => { if (sent) fireConfetti(); }, [sent]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Captured by Netlify Forms (Site -> Forms -> "contact") and emailed to the team.
      await submitNetlifyForm("contact", { name, email, phone, message, "bot-field": website });

      setSent(true);
      setName("");
      setEmail("");
      setPhone("");
      setMessage("");
    } catch (error) {
      console.error("❌ Error submitting form:", error);
      alert("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="ee-contact">
      <div className="ee-contact-hero">
        <div className="ee-section-label">Contact Us</div>
        <h1>Let’s talk trash. 🗑️♻️</h1>
        <p>Questions, donations, or a bulk pickup for your business? Send us a message and we’ll get back to you ASAP.</p>
      </div>

      <div className="ee-contact-body">
        <div className="ee-contact-card">
          {sent ? (
            <div className="ee-contact-success">
              <div className="ee-success-check">✅</div>
              <h2>Message sent!</h2>
              <p>Thanks for reaching out — we’ll be in touch soon.</p>
              <button onClick={() => setSent(false)} className="ee-btn ee-btn-green">Send Another Message</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <p className="ee-hidden" aria-hidden="true" style={{ position: 'absolute', left: '-9999px' }}>
                <label>Leave this field empty: <input type="text" value={website} onChange={(e) => setWebsite(e.target.value)} tabIndex={-1} autoComplete="off" /></label>
              </p>
              <div className="ee-field">
                <label>Your Name</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} required className="ee-input" placeholder="Jordan Rivera" />
              </div>
              <div className="ee-field-row">
                <div className="ee-field">
                  <label>Email</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="ee-input" placeholder="you@email.com" />
                </div>
                <div className="ee-field">
                  <label>Phone</label>
                  <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} className="ee-input" placeholder="(917) 555-0100" />
                </div>
              </div>
              <div className="ee-field">
                <label>Message</label>
                <textarea value={message} onChange={(e) => setMessage(e.target.value)} required rows={5} className="ee-input" placeholder="How can we help?" />
              </div>
              <button type="submit" disabled={loading} className="ee-btn ee-btn-green ee-btn-full">
                {loading ? "Sending…" : "Send Message"}
              </button>
            </form>
          )}
        </div>

        <aside className="ee-contact-side">
          <div className="ee-contact-info">
            <h3>Get in touch</h3>
            <div className="ee-contact-info-row"><span>📧</span><div><strong>Email</strong><a href="mailto:everythingeconyc@gmail.com">everythingeconyc@gmail.com</a></div></div>
            <div className="ee-contact-info-row"><span>📍</span><div><strong>Based in</strong>Williamsburg, Brooklyn — serving all of NYC</div></div>
            <div className="ee-contact-info-row"><span>⏱️</span><div><strong>Response time</strong>Usually within 24 hours</div></div>
          </div>
          <div className="ee-contact-map">
            <iframe
              title="Everything Eco service area — Brooklyn, NYC"
              src="https://www.openstreetmap.org/export/embed.html?bbox=-73.962%2C40.708%2C-73.931%2C40.722&layer=mapnik"
            ></iframe>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ContactPage;
